import { SeedingFloatingActionBar } from '../common/SeedingFloatingActionBar';
import type { SeedingPrimaryCtaSingle } from '../types';

interface ProposeSoldOutActionBarProps {
  cta: SeedingPrimaryCtaSingle;
  onAction: () => void;
}

export const ProposeSoldOutActionBar = ({ cta, onAction }: ProposeSoldOutActionBarProps) => (
  <SeedingFloatingActionBar
    mode="single"
    variant={cta.variant ?? 'blur'}
    primary={{
      label: cta.primary.label,
      disabled: cta.primary.disabled ?? false,
      onClick: onAction,
    }}
  />
);
